import Checkbox from "../../../shared/checkbox/checkbox";

const TelematicsOnDemandFilter = () => {
    return(
        <ul className={'filter-list round-corner-8 disabled'}>
            <li>
                <div className="filter-title margin-b-15">Vehicles</div>
                <div className="search-box margin-b-30 round-corner-8">
                    <input type="text" placeholder={'Search'}/>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>KA 05 HJ 1890</label>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>KA 06 HJ 1360</label>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>KA 07 HJ 2890</label>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>KA 02 HJ 7830</label>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>KA 05 HJ 1890</label>
                </div>
            </li>
        </ul>
    )
}

export default TelematicsOnDemandFilter;
